export default {
  collapsed: false,
};
